module.exports = __webpack_public_path__ + "img/DNADamage-ASHN_GSE227469.c263de8c.png";